<template>
  <CommonPages class="rankings-page" :class="['rankings-conatiner']" headerTheme="dark"
    titlePrefix="Rank">

    <div class="rankings-page__container">
      <!-- 排名内容区域 -->
      <div class="rankings-page__content">
        <!-- 排名标签导航 -->
        <div class="rankings-page__tabs">
          <div class="rankings-page__tab"
            :class="{'rankings-page__tab--active': activeTab === 'weekly'}"
            @click="selectTab('weekly')">
            <div class="rankings-page__tab-text">Weekly <span v-if="deviceType != 'mobile'">Hot
                Books</span></div>
          </div>
          <div class="rankings-page__tab"
            :class="{'rankings-page__tab--active': activeTab === 'monthly'}"
            @click="selectTab('monthly')">
            <div class="rankings-page__tab-text">Monthly <span v-if="deviceType != 'mobile'">Hot
                Books</span></div>
          </div>
          <div class="rankings-page__tab"
            :class="{'rankings-page__tab--active': activeTab === 'yearly'}"
            @click="selectTab('yearly')">
            <div class="rankings-page__tab-text">Yearly <span v-if="deviceType != 'mobile'">Hot
                Books</span></div>
          </div>
        </div>

        <!-- 排名列表展示区域 -->
        <div class="rankings-page__list-container">
          <!-- 列表加载中状态 -->
          <div v-if="loading" class="rankings-page__loading">
            <div class="rankings-page__loading-spinner"></div>
            <div class="rankings-page__loading-text">Loading data...</div>
          </div>

          <!-- 列表内容 -->
          <div v-else-if="paginatedBooks.length > 0" class="rankings-page__list">
            <template v-for="(book, index) in paginatedBooks">
              <div :key="index" class="rankings-page__book-item" @click="goToDetail(book)">

                <!-- 书籍封面 -->
                <div class="rankings-page__book-cover">
                  <!-- 排名徽章 -->
                  <div class="rankings-page__rank" v-if="index < 3 && currentPage == 1"
                    :class="'rank-' + (index + 1 + (currentPage - 1) * itemsPerPage)">
                    <div class="rankings-page__rank-badge">Top
                      {{ index + 1 + (currentPage - 1) * itemsPerPage }}</div>
                  </div>
                  <img :src="book.coverImage" :alt="book.title" class="rankings-page__cover-img"
                    @error="$event.target.src = require('@/assets/book_default_1.jpg')">
                </div>

                <!-- 书籍信息 -->
                <div class="rankings-page__book-info">
                  <div class="rankings-page__book-meta-group">
                    <div class="rankings-page__book-category">{{ book.category }}</div>
                    <div class="rankings-page__book-author">By {{ book.author }}</div>
                  </div>
                  <h3 class="rankings-page__book-title">{{ book.title }}</h3>
                  <div class="rankings-page__book-rating">
                    <img src="@/assets/star.svg" alt="Rating" class="rankings-page__rating-icon">
                    <span class="rankings-page__rating-value">{{ book.rating || '4.5' }}</span>
                  </div>
                  <p class="rankings-page__book-description">
                    {{ book.description || 'No description available.' }}
                  </p>
                </div>
              </div>

              <AdComponent
                v-if="deviceType == 'mobile' && $global.isObjectNotEmpty(adsensConfig) && adsensConfig?.categories && shouldInsertAdDeviece('categories',index) != -1"
                :key="`ad_cat_mobile_${index}`" :ref="'ads-cat-insert-1-' + index" class="m_padding"
                :ads="adsensConfig?.categories?.[shouldInsertAdDeviece('categories',index)]"
                :showDebug="showDebug" />
            </template>

          </div>

          <!-- 空状态 -->
          <div v-else class="rankings-page__empty">
            <div class="rankings-page__empty-text">No ranking data available</div>
          </div>

          <!-- 分页控制器 -->
          <div v-if="totalPages > 1" class="rankings-page__pagination">
            <button class="rankings-page__pagination-arrow" @click="prevPage"
              :disabled="currentPage === 1">
              <img src="@/assets/vector-left.svg" alt="Previous">
            </button>
            <div class="rankings-page__pagination-dots">
              <span v-for="page in totalPages" :key="page" class="rankings-page__pagination-dot"
                :class="{ 'rankings-page__pagination-dot--active': page === currentPage }"
                @click="goToPage(page)"></span>
            </div>
            <button class="rankings-page__pagination-arrow" @click="nextPage"
              :disabled="currentPage === totalPages">
              <img src="@/assets/vector-right.svg" alt="Next">
            </button>
          </div>
        </div>

      </div>
    </div>
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import AdComponent from '@/pages/components/AdComponent.vue'
import { mapGetters } from 'vuex'
import CommonPages from '@/pages/components/page_common.vue'
import '@/css/rankings.scss'

export default {
  name: 'Rankings',
  components: {
    CommonPages,
    AdComponent,
  },
  mixins: [common, adMixin, adTrackingMixin],
  computed: {
    ...mapGetters([
      'deviceType',
      "adsensConfig",
      'adPosConfig',
      'showDebug'
    ]),
    // 当前选中标签对应的图书列表
    currentBooks () {
      return this.booksByTab[this.activeTab] || []
    },
    // 总页数
    totalPages () {
      return Math.ceil(this.currentBooks.length / this.itemsPerPage)
    },
    // 当前页显示的图书
    paginatedBooks () {
      const start = (this.currentPage - 1) * this.itemsPerPage
      const end = start + this.itemsPerPage
      return this.currentBooks.slice(start, end)
    }
  },
  data () {
    return {
      activeTab: 'weekly',
      loading: false,
      currentPage: 1, // 当前页码
      itemsPerPage: 9, // 每页显示数量
      // 修改为与API返回格式匹配的键
      rankingTabs: ['weekly', 'monthly', 'yearly'],
      // 修改booksByTab对象结构与rankingTabs保持一致
      booksByTab: {
        weekly: [],
        monthly: [],
        yearly: []
      },
    }
  },
  watch: {
    '$route.query.tab': {
      immediate: true,
      handler (newTab) {
        if (newTab && this.rankingTabs.includes(newTab)) {
          this.activeTab = newTab;
        }
      }
    }
  },
  created () {
    this.fetchRankings()
  },
  methods: {
    shouldInsertAdDeviece (pos, index) {
      // 判断是否应该插入广告的位置
      const position = index + 1;
      // 在移动端检查位置是否在配置中，返回在配置数组中的索引
      // 例如：如果 position 是 1，且 adPosConfig[pos] 是 [1, 2]，则返回 0
      // 如果 position 是 2，且 adPosConfig[pos] 是 [1, 2]，则返回 1
      console.log(this.adPosConfig?.[pos]);
      console.log(position);
      const adIndex = this.adPosConfig?.[pos].indexOf(position);
      // 返回广告在配置中的索引位置，如果不在配置中则返回 -1
      return adIndex;
    },
    // 选择排行榜标签
    selectTab (tab) {
      this.activeTab = tab
      this.currentPage = 1 // 切换tab时重置到第一页
      // 如果该分类数据还未加载，则加载数据
      if (this.booksByTab[tab].length === 0) {
        this.fetchRankingsByType(tab)
      }
    },

    // 分页方法
    nextPage () {
      if (this.currentPage < this.totalPages) {
        this.currentPage++
      }
    },
    prevPage () {
      if (this.currentPage > 1) {
        this.currentPage--
      }
    },
    goToPage (page) {
      this.currentPage = page
    },

    // 获取所有排行榜数据
    async fetchRankings () {
      this.loading = true

      try {
        // 调用API获取排行榜数据
        const response = await this.$global.server.getRankList();

        if (response.data && response.data.result) {
          // 新的API返回格式为 {"result": {"MONTH": [], "YEAR": [], "WEEK": []}}
          const rankData = response.data.result;

          // 处理每个榜单类型的数据
          if (rankData.WEEK && Array.isArray(rankData.WEEK)) {
            this.booksByTab.weekly = this.processRankData(rankData.WEEK);
          }

          if (rankData.MONTH && Array.isArray(rankData.MONTH)) {
            this.booksByTab.monthly = this.processRankData(rankData.MONTH);
          }

          if (rankData.YEAR && Array.isArray(rankData.YEAR)) {
            this.booksByTab.yearly = this.processRankData(rankData.YEAR);
          }
        } else {
          console.warn('API returned ranking data format does not match expectations, using mock data');
        }
      } catch (error) {
        console.error('Failed to fetch ranking data:', error);

        // 出错时使用模拟数据
      } finally {
        this.loading = false;
      }
    },

    // 根据类型获取排行榜数据
    async fetchRankingsByType (type) {
      // 如果数据已存在，不再重新获取
      if (this.booksByTab[type] && this.booksByTab[type].length > 0) {
        return;
      }

      this.loading = true;

      try {
        // 调用API获取排行榜数据
        const response = await this.$global.server.getRankList();

        if (response && response.result) {
          // 从API响应中提取数据
          const rankData = response.result;

          // 根据type参数处理对应的榜单数据
          if (type === 'weekly' && rankData.WEEK && Array.isArray(rankData.WEEK)) {
            this.booksByTab.weekly = this.processRankData(rankData.WEEK);
          }
          if (type === 'monthly' && rankData.MONTH && Array.isArray(rankData.MONTH)) {
            this.booksByTab.monthly = this.processRankData(rankData.MONTH);
          }
          if (type === 'yearly' && rankData.YEAR && Array.isArray(rankData.YEAR)) {
            this.booksByTab.yearly = this.processRankData(rankData.YEAR);
          }
        } else {
          console.warn(`API returned ranking data format does not match expectations for ${type}, using mock data`);
        }
      } catch (error) {
        console.error(`Failed to fetch ${type} ranking data:`, error);
      } finally {
        this.loading = false;
      }
    },

    // 处理API返回的排行榜数据
    processRankData (booksData) {
      return booksData.map(book => ({
        id: book.id,
        title: book.novelName || 'Unknown Title',
        author: book.novelAuthorName || 'Unknown Author',
        category: book.novelType || 'Fiction',
        coverImage: book.bigImg || require('@/assets/book_default_1.jpg'),
        rating: book.novelScoreStr || '0',
        novelId: book.novelId || '',
        description: book.novelStoryIntro || 'No description available.',
      }));
    },

    // 跳转到书籍详情页
    goToDetail (book) {
      // 构建URL - 路由格式：/:categories/:novelName/:id
      const categoryParam = book.category ? book.category.toLowerCase().replace(/\s+/g, '-') : 'fiction';
      const titleParam = book.novelId ? book.novelId : book.title.toLowerCase().replace(/\s+/g, '-');
      const idParam = book.id;

      // 跳转到书籍详情页
      this.$router.push(`/${categoryParam}/${titleParam}/${idParam}`);
    }
  }
}
</script>

<style lang="scss">
// 样式已移至 @/css/rankings.scss
</style> 